/*
 * @Author: 李明明
 * @Date: 2022-07-28 09:33:50
 * @LastEditTime: 2022-10-20 09:19:50
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/store/index.js
 * 代码版权方：'政府采购信息网'
 */
import { createStore } from 'vuex'

export default createStore({
  state: {
    token: '',
    userInfo: {},
    resourceLoading: true,
    // 是否显示考试说明弹窗
    showExamExplain: false,
    // 显示考试说明弹窗的信息: 必须包含：signUpUserId  examId
    examExplainInfo: {}
  },
  mutations: {
    login: (state,data)=>{
      console.log(state,data);
    }
  },
  actions: {
  },
  modules: {
  }
})
